import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class AgentPreferencesService {
  constructor(getDatabase, pubsub) {
    this.pubsub = pubsub;
    this.preferences = {};
  }

  get(data, callback, path, { orgId, agentId }) {
    callback(null, { status: 200, statusText: statusText(200), response: this.preferences });
  }

  set(dto, callback, path, { orgId, agentId }) {
    this.preferences = { ...dto, id: agentId };

    this.pubsub.publish(`v1/orgs/${orgId}/agents/${agentId}/preferences`, {
      payload: this.preferences,
    });

    callback(null, { status: 200, statusText: statusText(200), response: this.preferences });
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/agents/:agentId/preferences': {
          GET: this.get,
          PUT: this.set,
        },
      },
      this
    );
  }
}
